import * as React from 'react';
import * as MenuConfig from '../../../../typings/menu';
import { StyledHeaderSection } from '../styles';
import HeaderLogo from '../../../../containers/MenuManager/Header/Logo';
import HeaderButton from '../../../../containers/MenuManager/Header/HeaderButton';
import ShareButton from '../../../../containers/Share/ShareButton';
import SearchButton from '../../../../containers/DriveItemList/Search/Button';
import { Api } from '../../../../typings/api';
import DriveItemDownloadButton from '../../../../containers/DriveItem/DownloadButton';
import { DriveItemListOrigin } from '../../../../containers/DriveItemListPage/constants';
import RoutesUtils from '../../../../utils/routes';
import { ActionButtonStyle } from '../../../../utils/driveItem';
import { ShareOrigin } from '../../../../containers/Share/actions';
import { StyledTitle } from '../../../Title/styles';
import { Translate } from 'react-redux-i18n';
import CancelButton from '../HeaderButton/CancelButton';
import { CancelActionOrigin } from '../../../../containers/MenuManager/constants';
import ButtonCreate from '../../../../containers/ButtonCreate';

interface HeaderSectionProps {
	position: MenuConfig.MenuPosition;
	menuItems: MenuConfig.MenuItem[];
	driveItems?: Api.DriveFolderInfo[];
	privateDirId: number | undefined;
	sharedDirId: number | undefined;
	isButtonCreateAvailable: boolean;
}

class HeaderSection extends React.Component<HeaderSectionProps, {}> {

	render() {
		const { menuItems, position } = this.props;

		return (
			<StyledHeaderSection position={position}>
				{menuItems
					? menuItems.map((menuItem, index) => this.getMenuItemElement(menuItem, `header-button-${index}`))
					: null
				}
			</StyledHeaderSection>
		);
	}

	getMenuItemElement(menuItem: MenuConfig.MenuItem, key: string) {
		const { driveItems, privateDirId, sharedDirId, isButtonCreateAvailable, position } = this.props;
		let itemArgs;

		switch (menuItem.type) {
			case MenuConfig.MenuItemType.Home:
				itemArgs = {
					icon: 'iconset_home',
					label: 'messages.home',
					type: menuItem.type,
					target: RoutesUtils.getPathHome(),
				};
				break;
			case MenuConfig.MenuItemType.Gallery:
				itemArgs = {
					icon: 'iconset_image',
					label: 'messages.my_gallery',
					type: menuItem.type,
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, null),
				};
				break;
			case MenuConfig.MenuItemType.BurgerButton:
				itemArgs = {
					icon: 'iconset_uprez_menu',
					label: 'messages.menu',
					type: menuItem.type,
				};
				break;
			case MenuConfig.MenuItemType.Logo:
				return <HeaderLogo key={key} />;
			case MenuConfig.MenuItemType.DownloadButton:
				return <DriveItemDownloadButton driveItems={driveItems ? driveItems : []} style={ActionButtonStyle.Icon} key={key} />;
			case MenuConfig.MenuItemType.ShareButton:
				return <ShareButton driveItems={driveItems ? driveItems : []} shareOrigin={ShareOrigin.Selection} key={key} />;
			case MenuConfig.MenuItemType.SearchButton:
				return <SearchButton key={key} />;
			case MenuConfig.MenuItemType.CancelButton:
				return <CancelButton key={key} actionOrigin={menuItem.target as CancelActionOrigin} />;
			case MenuConfig.MenuItemType.Selection:
				itemArgs = {
					label: 'messages.my_selection',
					icon: 'iconset_uprez_selection',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Selection, null),
					type: MenuConfig.MenuItemType.Selection,
				};
				break;
			case MenuConfig.MenuItemType.Title:
				return <StyledTitle key={key}><Translate value={menuItem.label} /></StyledTitle>;
			case MenuConfig.MenuItemType.New:
				itemArgs = {
					icon: 'iconset_news',
					label: 'messages.new',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.New, null),
				};
				break;
			case MenuConfig.MenuItemType.Documents:
				itemArgs = {
					icon: 'iconset_uprez_documents',
					label: 'messages.my_documents',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, String(privateDirId)),
					type: MenuConfig.MenuItemType.Documents,
				};
				break;
			case MenuConfig.MenuItemType.SharedWithMe:
				itemArgs = {
					label: 'messages.shared_with_me',
					icon: 'iconset_shared_with_me',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, String(sharedDirId))
				};
				break;
			case MenuConfig.MenuItemType.Downloads:
				itemArgs = {
					label: 'messages.downloads',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Downloads, null),
				};
				break;
			case MenuConfig.MenuItemType.Parameters:
				itemArgs = {
					icon: 'iconset_parameters',
					label: 'messages.parameters',
					target: RoutesUtils.getPathParameters(),
				};
				break;
			case MenuConfig.MenuItemType.Link:
				itemArgs = {
					type: MenuConfig.MenuItemType.Link,
					label: menuItem.label ? menuItem.label : 'Link',
					icon: menuItem.icon ? menuItem.icon : 'iconset_link',
					target: menuItem.target
				};
				break;
			case MenuConfig.MenuItemType.Asset:
				itemArgs = {
					type: MenuConfig.MenuItemType.Asset,
					label: menuItem.label ? menuItem.label : 'Asset',
					icon: menuItem.icon ? menuItem.icon : 'iconset_file',
					target: menuItem.target
				};
				break;
			case MenuConfig.MenuItemType.Folder:
				itemArgs = {
					type: MenuConfig.MenuItemType.Folder,
					label: menuItem.label ? menuItem.label : 'Folder',
					icon: menuItem.icon ? menuItem.icon : 'iconset_folder',
					target: menuItem.target
				};
				break;
			case MenuConfig.MenuItemType.Page:
				itemArgs = {
					type: MenuConfig.MenuItemType.Page,
					label: menuItem.label ? menuItem.label : 'Page',
					icon: menuItem.icon ? menuItem.icon : 'iconset_page',
					target: menuItem.target,
				};
				break;
			case MenuConfig.MenuItemType.CreateButton:
				return isButtonCreateAvailable
					? (
						<ButtonCreate
							key={key}
							options={menuItem.options as MenuConfig.CreateButtonOption[]}
							position={position}
						/>
					)
					: null;
		}

		if (itemArgs) {
			return (
				<HeaderButton
					label={itemArgs.label}
					icon={itemArgs.icon}
					type={itemArgs.type}
					target={itemArgs.target}
					key={key}
				/>);
		}

		return null;
	}
}

export default HeaderSection;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/Section/index.tsx